import React, {Component} from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {UserAction} from '../actions/UserAction'
import {CommonAction} from '../actions/CommonAction'
import $ from "jquery";

class Footer extends Component {

    scrollToTop() {
        $('html, body').animate({
            scrollTop: $("html").offset().top
        }, 1000);
    }

    render() {

        if (window.location
            && window.location.pathname
            && window.location.pathname.includes("documentation")
            && $(window).innerWidth() < 799) {
            return ""
        }

        return (
            <>
                <button className="scroll-top scroll-to-target"
                        data-target="html"
                        onClick={() => this.scrollToTop()}>
                    <span className="fa fa-angle-up"/>
                </button>
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
        common: state.common
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        userAction: UserAction,
        commonAction: CommonAction
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Footer)